import React from 'react';

export default ({ big = false, children, left = false }) => {
  return (
    <div style={{ fontSize: big ? 12 : 10, textAlign: left ? 'left' : 'right' }}>
      {children}
    </div>
  );
};
